import { useEffect, useRef, useState } from "react";
import algoliasearch, { SearchIndex } from "algoliasearch";
import { ArticleCardGroup } from "../article-card-group";
import { DividerLink } from "../divider-link/DividerLink";
import WineGlassIcon from "./WineGlassIcon";
import WhiskyGlassIcon from "./WhiskyGlassIcon";
import { Box } from "@vinomofo/components";

interface SearchResult {
  objectID: string;
  title: string;
  publishedDate: string;
}

const ArticleLoader = (props: { __typename: string; staticType: string }) => {
  const { staticType } = props;
  const isWhiskymofo = staticType === "Whiskymofo Article Loader";
  const client = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  );
  const index: SearchIndex = client.initIndex(
    process.env.GATSBY_ALGOLIA_ARTICLES_INDEX
  );
  const brand = process.env.GATSBY_VM_WM_SITE_NAME || "VM";

  const [items, setItems] = useState<SearchResult[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [totalHits, setTotalHits] = useState<number | null>(null);
  const loaderRef = useRef<HTMLDivElement | null>(null);

  const fetchItems = async (page: number) => {
    setIsLoading(true);
    try {
      const { hits, nbHits } = await index.search<SearchResult>("", {
        hitsPerPage: 12,
        page,
        filters: isWhiskymofo
          ? "isWhiskymofoArticle:True"
          : "isVinomofoArticle:True",
      });
      setItems((prevItems) => [...prevItems, ...hits]);
      setTotalHits(nbHits);
    } catch (error) {
      console.error("Error fetching items from Algolia:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initLoad();
  }, []);

  const loadMore = () => {
    fetchItems(currentPage + 1);
    setCurrentPage((prevPage) => prevPage + 1);

    setTimeout(() => {
      loaderRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  const initLoad = () => {
    fetchItems(currentPage);
    setCurrentPage((prevPage) => prevPage + 1);
  };

  return (
    <div>
      <ArticleCardGroup hits={items} rowNumber={4} />
      <Box
        display="flex"
        flexDirection={"column"}
        alignItems="center"
        width="100%"
      >
        <div style={{ width: "35px" }}>
          {brand === "WM" ? <WhiskyGlassIcon /> : <WineGlassIcon />}
        </div>
      </Box>
      <div ref={loaderRef}>
        {!isLoading && items.length < (totalHits ?? Infinity) && (
          <div
            style={{ marginTop: "30px", marginBottom: "40px" }}
            onClick={loadMore}
          >
            <DividerLink label="Load More" isExternal />
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticleLoader;
